import React from "react";
import { styled } from "styled-components";
import Button from "../button/button";
import { t } from 'ttag';

const Wrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 50vh;
  
  button {
    width: auto;
    margin-left: 10px;
  }
  
  @media (max-width: 768px) {
    button {
      margin-left: 10px;
    }
  }
`;

const Section = styled.section`
`;

const FeedbackSent = ({ onSubmit }) => {
  return (
    <Wrapper>
      <Section>
        <h2>{t`Feedback Sent`}</h2>
        <div className='row mt-2'>
          <div className='col-12'>
            {t`Thank you for your feedback. We will assign an administrator to review your submission. Please note this usually takes up to 72 hours, however, a response from the administrator is at their discretion.`}
          </div>
        </div>
        <div className='row mt-4'>
          <Button title={t`Send another feedback`} onClick={() => {
            if (onSubmit) {
              onSubmit();
            }
          }} />
        </div>
        <div className='row mt-5'>
          <div className='col-12'>
            {t`While you wait, please check out the`} <a href='https://www.easyllama.com/resources/'>{t`EasyLlama resources`}</a> {t`page`}.
          </div>
        </div>
      </Section>
    </Wrapper>
  );
};

export default FeedbackSent;
